export const headers = {
  Accept: "application/json",
  "Content-Type": "application/json; charset=UTF-8",
};
